import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.blackwave.augustow.pl';
const DEFAULT_IMAGE = `${SITE_URL}/images/bg/bg-image-15.webp`;

const SEO = ({
  title,
  description,
  canonicalPath = '/',
  image = DEFAULT_IMAGE,
  robots = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
  type = 'website',
  structuredData = [],
  preloadImage = null,
  preloadType = null,
}) => {
  const canonicalUrl = canonicalPath == null ? null : `${SITE_URL}${canonicalPath === '/' ? '/' : canonicalPath}`;
  const schemas = Array.isArray(structuredData) ? structuredData : [structuredData];

  return (
    <Helmet htmlAttributes={{ lang: 'pl' }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}
      {canonicalUrl ? <link rel="alternate" hrefLang="pl-PL" href={canonicalUrl} /> : null}
      {canonicalUrl ? <link rel="alternate" hrefLang="x-default" href={canonicalUrl} /> : null}
      {preloadImage ? <link rel="preload" as="image" href={preloadImage} type={preloadType || undefined} fetchPriority="high" /> : null}

      <meta property="og:locale" content="pl_PL" />
      <meta property="og:site_name" content="BlackWave Augustów" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="BlackWave — wynajem łodzi motorowych w Augustowie" />
      {canonicalUrl ? <meta property="og:url" content={canonicalUrl} /> : null}
      <meta property="og:type" content={type} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schemas.filter(Boolean).map((schema, index) => (
        <script type="application/ld+json" key={index}>
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
